// 반 이름 목록과 classes 데이터를 받아서 배지로 렌더링하는 헬퍼 함수
import Badge from '../components/Badge';

interface ClassInfo {
  id?: number;
  className: string;
  classCategory?: 'regular' | 'special' | 'supplement';
}

// 반 배지 색상 결정
export const getClassBadgeProps = (classCategory?: string) => {
  if (classCategory === 'regular') {
    // 정규반: 파란색
    return {
      backgroundColor: 'rgba(227, 242, 253, 0.8)',
      textColor: '#1976d2',
      borderColor: 'rgba(33, 150, 243, 0.35)',
    };
  } else if (classCategory === 'special') {
    // 특강반: 초록색
    return {
      backgroundColor: 'rgba(76, 175, 80, 0.15)',
      textColor: '#2e7d32',
      borderColor: 'rgba(76, 175, 80, 0.35)',
    };
  }
  // 기본값 (보강반 또는 미분류)
  return {
    backgroundColor: '#f3f4f6',
    textColor: '#6b7280',
    borderColor: '#d1d5db',
  };
};

// 쉼표로 구분된 반 이름 문자열을 배지로 렌더링
export const renderClassBadges = (
  classString: string,
  allClasses: ClassInfo[],
  onClick?: () => void
) => {
  if (!classString || classString.trim() === '') {
    return <span style={{ color: '#999', fontSize: 13 }}>없음</span>;
  }

  // 쉼표로 구분된 반 이름들
  const classNames = classString.split(',').map(name => name.trim()).filter(Boolean);

  // 반 이름으로 classCategory 찾기
  const classesWithCategory = classNames.map(name => {
    const classInfo = allClasses.find(c => c.className === name);
    return {
      name,
      category: classInfo?.classCategory,
    };
  });

  // 정규반 먼저, 특강반 나중에 정렬
  const sortedClasses = [...classesWithCategory].sort((a, b) => {
    const categoryOrder = { regular: 0, special: 1, supplement: 2 };
    const aOrder = categoryOrder[a.category as keyof typeof categoryOrder] ?? 3;
    const bOrder = categoryOrder[b.category as keyof typeof categoryOrder] ?? 3;
    return aOrder - bOrder;
  });

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      {sortedClasses.map((cls, idx) => {
        const badgeProps = getClassBadgeProps(cls.category);
        return (
          <Badge key={`${cls.name}-${idx}`} {...badgeProps}>
            {cls.name}
          </Badge>
        );
      })}
    </div>
  );
};
